import React from 'react';

// Context wrappers
import StylesWrapper from './styles';

function Context({ children }) {
  return <StylesWrapper>{children}</StylesWrapper>;
}

export default Context;
